'use client';

import React, { useState } from 'react';
import { useGetEngageStrategyDetailsQuery } from 'src/api/redux/strategy/engageStrategyApi';
import { StrategyProfileHeader } from '../../components/StrategyProfileHeader';
import { StrategyProfileMap } from '../../components/StrategyProfileMap';
import { StrategyProfileList } from '../../components/StrategyProfileList';
import StrategyProfileLayout from '../StrategyProfileLayout';

type View = 'map' | 'list';

interface NotReferringViewProps {
  engageStrategyId: string;
}

const NotReferringView: React.FC<NotReferringViewProps> = ({
  engageStrategyId,
}) => {
  const [view, setView] = useState<View>('map');

  const { data: engageStrategyDetails } = useGetEngageStrategyDetailsQuery(
    engageStrategyId,
    { skip: !engageStrategyId }
  );

  return (
    <StrategyProfileLayout>
      <StrategyProfileHeader
        view={view}
        setView={setView}
        description={engageStrategyDetails?.description || ''}
        title={engageStrategyDetails?.label || ''}
        isEngageStrategy={true}
      />

      {view === 'map' ? (
        <StrategyProfileMap engageStrategyId={engageStrategyId} />
      ) : (
        <StrategyProfileList engageStrategyId={engageStrategyId} />
      )}
    </StrategyProfileLayout>
  );
};

export default NotReferringView;
